export type RouteGroup = {
    groupName: string;
    routeRows: RouteInfo[][];
};

export type RouteInfo = {
    noAuth?: boolean;
    menuId: string;

    /**
     *  @description This is a default name.
     * It should be display only when `menu_name` from each one of `adminDetails` is undefined
     * */
    menuName: string;

    pathname: string;
};

export const routeGroups: RouteGroup[] = [
    {
        groupName: 'Workflow Config',
        routeRows: [
            [
                {
                    menuId: 'ADM-WF300',
                    menuName: 'การกำหนดพนักงานอีเมลบนเวป',
                    pathname: '/MasterEmployee'
                },
                {
                    menuId: 'ADM-WF301',
                    menuName: 'การกำหนดบทบาทกับพนักงาน',
                    pathname: '/roleemployee'
                },
                {
                    menuId: 'ADM-WF302',
                    menuName: 'การกำหนดกลุ่มสิทธิ์ WF กับพนักงาน',
                    pathname: '/authoritygroup'
                },
                {
                    menuId: 'ADM-WF304',
                    menuName: 'ข้อมูลหลักพารามิเตอร์ WF',
                    pathname: '/conditionmaster'
                },
                {
                    menuId: 'ADM-WF305',
                    menuName: 'ข้อมูลการเรียกกลับ WF',
                    pathname: '/callbackconfigmaster'
                },
                {
                    menuId: 'ADM-WF303',
                    menuName: 'การจัดการเวิร์กโฟลว์',
                    pathname: '/workflow'
                },
                {
                    menuId: 'ADM-WF307',
                    menuName: 'กำหนดค่าสรุปอินบ๊อกซ์เวิร์กโฟลว์',
                    pathname: '/workflowinboxadminsummary'
                },
                {
                    menuId: 'ADM-WF306',
                    menuName: 'กำหนดค่าอินบ๊อกซ์เวิร์กโฟลว์',
                    pathname: '/workflowinboxadmin'
                },
                {
                    menuId: 'ADM-WF308',
                    menuName: 'ข้อมูลรายการเวิร์กโฟลว์',
                    pathname: '/workflowlog'
                },
                {
                    menuId: 'ADM-WF309',
                    menuName: 'ข้อมูลรายการอีเมลเวิร์กโฟลว์',
                    pathname: '/workflow-email-log'
                }
            ],
            [
                {
                    menuId: 'RPT-WF202',
                    menuName: 'รายงานอินบ๊อกซ์เวิร์กโฟลว์ (แอดมิน)',
                    pathname: '/workflowinboxadminsummary'
                },
                {
                    menuId: 'RPT-WF203',
                    menuName: 'รายงานเงื่อนไขเวิร์กโฟลว์(แอดมิน)',
                    pathname: '/workflowconditionconfigurationreport'
                },
                {
                    menuId: 'RPT-WF204',
                    menuName: 'รายงานระดับสิทธิ์เวิร์กโฟลว์(แอดมิน)',
                    pathname: '/workflowassignmentroutingreport'
                }
            ],
            [
                {
                    menuId: 'BETA001',
                    menuName: 'Role Master Employee',
                    pathname: '/rolemasteremployee'
                },
                {
                    menuId: 'BETA002',
                    menuName: 'Callback Stat',
                    pathname: '/callbacklogstart'
                },
                {
                    menuId: 'BETA003',
                    menuName: 'Callback Log',
                    pathname: '/callbacklog'
                },
                {
                    menuId: 'BETA004',
                    menuName: 'Workflow Config Add Admin',
                    pathname: '/createUserAdmin'
                },
                {
                    menuId: 'BETA005',
                    menuName: 'กำหนดค่าแดชบอร์ดเวิร์กโฟลว์',
                    pathname: '/workflowreport'
                },
                {
                    menuId: 'BETA006',
                    menuName: 'Workflow Log Buffer',
                    pathname: '/workflowlogbuffer'
                },
                {
                    menuId: 'BETA007',
                    menuName: 'Workflow Buffer Stat',
                    pathname: '/bufferstat'
                },
                {
                    menuId: 'BETA008',
                    menuName: 'Workflow Assignment Routing Config',
                    pathname: '/assignmentroutingconfig'
                },
                {
                    menuId: 'BETA009',
                    menuName: 'Authentication History',
                    pathname: '/auth-history'
                },
                {
                    menuId: 'BETA010',
                    menuName: 'Export Employee Roles',
                    pathname: '/export-employee-roles'
                },
                {
                    menuId: 'BETA011',
                    menuName: 'Email Config',
                    pathname: '/email-config'
                },
                {
                    menuId: 'BETA012',
                    menuName: 'Workflow Usage Rate',
                    pathname: '/workflow-usage-rate'
                },
                {
                    menuId: 'BETA013',
                    menuName: 'Workflow Performance Search',
                    pathname: '/workflow-performance'
                },
                {
                    menuId: 'BETA014',
                    menuName: 'Workflow Type Master Config',
                    pathname: '/workflow-type-master-config'
                },
                {
                    menuId: 'BETA015',
                    menuName: 'Workflow Menu Master Config',
                    pathname: '/workflow-menu-master-config'
                },
                {
                    menuId: 'BETA016',
                    menuName: 'Workflow Role Master Config',
                    pathname: '/workflow-role-master-config'
                },
                {
                    menuId: 'BETA017',
                    menuName: 'Line Config',
                    pathname: '/line-config'
                },
                {
                    menuId: 'BETA018',
                    menuName: 'Recurring Job Log',
                    pathname: '/recuring-job-log'
                }
            ]
        ]
    },
    {
        groupName: 'Workflow Working',
        routeRows: [
            [
                {
                    noAuth: true,
                    menuId: 'RPT-WF200',
                    menuName: 'รายงานแดชบอร์ดเวิร์กโฟลว์',
                    pathname: '/workflowdashboard'
                },
                {
                    noAuth: true,
                    menuId: 'RPT-WF201',
                    menuName: 'รายงานอินบ๊อกซ์เวิร์กโฟลว์',
                    pathname: '/workflowinbox'
                },
                {
                    noAuth: true,
                    menuId: 'UBETA001',
                    menuName: 'สร้างเอกสารเวิร์กโฟลว์',
                    pathname: '/createworkflow'
                },
                {
                    noAuth: true,
                    menuId: 'UBETA002',
                    menuName: 'สร้างเอกสารเวิร์กโฟลว์ด้วยประเภท',
                    pathname: '/createworkflowwithwftype'
                },
                {
                    noAuth: true,
                    menuId: 'UBETA003',
                    menuName: 'จำลองรายการเวิร์กโฟลว์',
                    pathname: '/simulateworkflow'
                }
            ]
        ]
    }
];
